import { FormFieldComparator } from 'app/form-fields/common/edit/form-field-comparator';

export class FormYesNoComparator implements FormFieldComparator {
  isEqual(previous, next) {
    return previous.checked === next.checked && previous.textInputValue === next.textInputValue;
  }
}
